import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { calculatePositions } from 'utils/redux'
import sortedLayoutsSelector from '../selectors/sortedLayouts'
import {
  addLayout as addLayoutToView
} from '../redux/view'
import {
  add as addLayout,
  setPosition as setLayoutPosition
} from '../redux/layouts'

export default function * requestAddMyLayout (action) {
  const { id, position } = action.payload

  const state = yield select()

  const layouts = sortedLayoutsSelector(state)

  const positions = calculatePositions({
    array: layouts,
    position
  })

  const optimisticAction = yield optimisticPut([
    addLayout({
      id,
      position,
      isBusy: true
    }),
    addLayoutToView({
      id
    }),
    ...positions.map(({ id, position }) =>
      setLayoutPosition({
        id,
        position
      })
    )
  ])

  try {
    yield call(apiAction, 'AddMyHomeLayout', {
      homeLayoutId: id,
      position
    })
  } finally {
    yield optimisticAction.revert()
  }
}
